import { Event } from '../../domain/event/Event';
import { EventDTO } from '../../domain/event/EventDTO';

export class EventMapper {
  static toDomain(props: EventDTO): Event {
    const { object_id, type, data, meta, created_by, created_at } = props;
    return Event.create({
      meta,
      type,
      created_at,
      created_by,
      object_id,
      data,
    });
  }

  static toDTO(event: Event): EventDTO {
    return {
      created_at: event.created_at,
      created_by: event.created_by,
      meta: event.meta,
      object_id: event.object_id,
      type: event.type,
      data: event.data,
    };
  }
}
